var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "100%",
    height: "100%",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 27940 21590",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_817309312"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M12861 14384c0,-119 116,-234 242,-234l2177 0c91,0 210,89 210,163l0 3862 -2629 0 0 -3791zm1319 -11397l0 0c-119,79 -221,132 -359,202l-10897 5999c460,0 920,1 1380,0 273,0 414,7 491,212 76,205 2,790 0,981l-46 7817 7489 -23 0 -3862c0,-235 128,-491 267,-599 91,-71 156,-130 268,-176 88,-36 223,-67 354,-67l2176 0c379,0 660,245 790,544 50,117 76,183 76,345l0 3815 7419 23 -47 -8261c0,-250 -64,-453 45,-610 125,-179 278,-139 563,-139 460,0 921,0 1381,0 -24,-21 -45,-39 -80,-61l-11270 -6140zm-12988 6529l0 0c0,290 206,353 444,351l2344 -28c190,-3 159,48 161,214l-47 8240c0,176 -42,490 99,490l20003 0c99,0 73,-105 71,-210l-71 -8496c-4,-256 -36,-233 234,-233l2437 -32c156,-2 229,-163 247,-315 36,-309 -406,-437 -670,-591l-11789 -6441c-462,-259 -425,-286 -901,3l-11841 6482c-308,186 -721,309 -721,566z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M19867 15320l1872 0 0 1357 -1872 0 0 -1357zm-2177 0l0 0 1826 0 0 1357 -1826 0 0 -1357zm0 -1943l0 0 1826 0 0 1592 -1826 0 0 -1592zm2177 1521l0 0 0 -1450c0,-54 16,-71 70,-71l1732 0c53,0 70,17 70,71l0 1450c0,54 -17,71 -70,71l-1732 0c-54,0 -70,-17 -70,-71zm-2645 -1427l0 0 0 3136c0,362 177,538 538,538l3932 0c261,0 491,-159 491,-374l0 -3440c0,-222 -175,-398 -397,-398l-4143 0c-302,0 -421,253 -421,538z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    d: "M8774 15203l1802 0 0 1334 -1802 0 0 -1334zm-2176 0l0 0 1778 0c54,0 70,16 70,70l0 1264 -1848 0 0 -1334zm2176 -398l0 0 0 -1521 1802 0 0 1591 -1732 0c-54,0 -70,-16 -70,-70zm-398 70l0 0 -1778 0 0 -1591 1778 0c54,0 70,16 70,70l0 1451c0,54 -16,70 -70,70zm-2223 -1708l0 0 0 3510c0,206 248,351 468,351l3932 0c303,0 491,-188 491,-491l0 -3230c0,-166 -35,-235 -122,-323 -81,-81 -142,-145 -299,-145l-4072 0c-173,0 -398,169 -398,328z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M16216 9352l913 0 0 609 -913 0 0 -609zm1264 538l0 0 0 -538 1497 0c105,0 913,470 1083,579 42,27 16,9 41,30l-2341 0c-114,0 -280,36 -280,-71zm0 -1380l0 0c97,8 752,369 865,468l-865 0 0 -468zm-1264 -726l0 0c81,19 592,315 697,379 271,164 216,-47 216,815l-913 0 0 -1194zm-468 -421l0 0 0 2832c0,270 328,259 561,258 281,-2 562,-1 843,-1 283,0 516,-23 819,-23l2925 0c127,0 149,48 252,-29 405,-304 -247,-526 -458,-654 -119,-72 -210,-119 -332,-183 -110,-57 -218,-131 -327,-188l-660 -369c-606,-368 -1398,-764 -1995,-1118 -199,-118 -1265,-736 -1347,-736 -133,0 -281,32 -281,211z",
    fill: "#808080"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M11138 9282l912 0 0 608 -912 0 0 -608zm-1802 0l0 0 1451 0 0 608 -2575 0c121,-105 1048,-608 1124,-608zm1802 -1006l0 0c0,-69 28,-58 75,-88 45,-28 74,-42 119,-69 147,-86 608,-356 718,-382l0 1194 -912 0 0 -655zm-351 163l0 0 0 492 -866 0 866 -492zm-3745 1685l0 0c0,103 103,212 184,240 53,19 254,-6 378,-6l4212 0c140,0 284,4 423,2 138,-2 235,-56 254,-167 45,-253 25,-2636 25,-2853 0,-102 -81,-234 -257,-234 -123,0 -632,312 -756,391l-1904 1067c-223,134 -441,240 -662,368l-1644 931c-107,65 -253,100 -253,261z",
    fill: "#808080"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSingle);
export default __webpack_public_path__ + "static/media/single.b21da1a8650113e18254e41c1129697f.svg";
export { ForwardRef as ReactComponent };